import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M13.8623 10.9963C13.5154 10.3988 12.9998 8.70813 12.9998 6.5C12.9998 5.17392 12.473 3.90215 11.5353 2.96447C10.5976 2.02678 9.32585 1.5 7.99976 1.5C6.67368 1.5 5.40191 2.02678 4.46423 2.96447C3.52655 3.90215 2.99976 5.17392 2.99976 6.5C2.99976 8.70875 2.48351 10.3988 2.13664 10.9963C2.04806 11.1482 2.0011 11.3207 2.00049 11.4966C1.99989 11.6724 2.04566 11.8453 2.1332 11.9978C2.22074 12.1503 2.34694 12.277 2.49908 12.3652C2.65122 12.4534 2.82392 12.4999 2.99976 12.5H5.55039C5.66575 13.0645 5.97253 13.5718 6.41885 13.9361C6.86517 14.3004 7.42362 14.4994 7.99976 14.4994C8.57591 14.4994 9.13436 14.3004 9.58068 13.9361C10.027 13.5718 10.3338 13.0645 10.4491 12.5H12.9998C13.1756 12.4998 13.3482 12.4532 13.5002 12.365C13.6523 12.2768 13.7784 12.15 13.8659 11.9975C13.9533 11.845 13.999 11.6722 13.9984 11.4964C13.9978 11.3206 13.9508 11.1481 13.8623 10.9963ZM7.99976 13.5C7.68965 13.4999 7.38719 13.4037 7.13401 13.2246C6.88084 13.0455 6.68939 12.7924 6.58601 12.5H9.41351C9.31014 12.7924 9.11869 13.0455 8.86552 13.2246C8.61234 13.4037 8.30988 13.4999 7.99976 13.5Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconBell'

export const IconBell = memo(themed(Icon))
